// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__nESQB","activeStyle":"Menu_activeStyle__9kKnY","unactiveStyle":"Menu_unactiveStyle__d-qxK"};